import { Color, IconName } from '@billy/design-system'

import { AttachmentTagVariant } from '../types/attachmentTagVariant'

interface TagStyles {
  iconColor?: Color
  iconName?: IconName
  textColor: Color
}

export const variantStyles: Record<AttachmentTagVariant, TagStyles> = {
  error: {
    iconColor: Color.Red700,
    iconName: 'circleAlert',
    textColor: Color.Red700,
  },
  neutral: { textColor: Color.Grey950 },
}
